export default "__VITE_ASSET__C_692MAs__"